import i18n from "@/shared/config/i18n";
import { getECPMessage } from "./signAndRunNclayer";

export default class NclayerPort {
  constructor() {
    this.wsUrl = "wss://127.0.0.1:13579/";
    this.socket = null;
  }
  async connect() {
    if (this.socket?.readyState === WebSocket.OPEN) {
      return this.socket;
    }

    return new Promise((resolve, reject) => {
      const ws = new WebSocket(this.wsUrl);

      ws.onopen = () => {
        this.socket = ws;
        resolve(ws);
      };

      ws.onerror = (err) => {
        console.error("Ошибка подключения к NCALayer:", err);
        this.socket = null;
        reject(new Error(i18n.global.t("NCALAYER_PORT_UNAVAILABLE")));
      };

      ws.onclose = () => {
        this.socket = null;
      };
    });
  }

  async sign(data) {
    const ws = await this.connect();

    if (!ws || ws.readyState !== WebSocket.OPEN) {
      console.warn("NCALayer: нет активного соединения через WebSocket");
      return { signatures: [] };
    }

    const locale = "ru"; // можно позже сделать динамическим
    ws.send(getECPMessage(data, locale));

    return new Promise((resolve, reject) => {
      const onMessage = ({ data }) => {
        try {
          if (!data.trim()) return;

          const resp = JSON.parse(data);

          if (resp?.status === true) {
            ws.removeEventListener("message", onMessage);

            if (
              Array.isArray(resp.body?.result) &&
              resp.body.result.length > 0
            ) {
              resolve({ signatures: resp.body.result });
            } else {
              reject(new Error(i18n.global.t("Действие отменено")));
            }

            return;
          }

          if (resp?.status === false || resp?.error) {
            ws.removeEventListener("message", onMessage);
            reject(
              new Error(
                resp.error || i18n.global.t("Ошибка при подписании данных")
              )
            );
          }
        } catch (e) {
          ws.removeEventListener("message", onMessage);
          reject(e);
        }
      };

      ws.addEventListener("message", onMessage);

      ws.onerror = () => {
        ws.removeEventListener("message", onMessage);
        reject(new Error(i18n.global.t("NCALAYER_SIGN_ERROR")));
      };
    });
  }
}
